import { render, staticRenderFns } from "./DiseaseAnalysisComponent.vue?vue&type=template&id=8a5fb94a&"
import script from "./DiseaseAnalysisComponent.vue?vue&type=script&lang=js&"
export * from "./DiseaseAnalysisComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports